
const firebaseConfig = {
  apiKey: "AIzaSyACQrkIW-vcFt8zyKA_ribhCEHVIu58X-Q",
  authDomain: "bostadsvaljare-vatterhem.firebaseapp.com",
  projectId: "bostadsvaljare-vatterhem",
  storageBucket: "bostadsvaljare-vatterhem.appspot.com",
  messagingSenderId: "780196893850",
  appId: "1:780196893850:web:ffb69b5fc5c65bc75b3b23",
  measurementId: "G-26LB3KYWTT"
};

// const firebaseConfig = {
//   apiKey: "AIzaSyBo8yIWUE9UBfiU1OhEIu2QtgY2T_xbCAg",
//   authDomain: "test-1c6eb.firebaseapp.com",
//   databaseURL: "https://test-1c6eb.firebaseio.com",
//   projectId: "test-1c6eb",
//   storageBucket: "test-1c6eb.appspot.com",
//   messagingSenderId: "60602324384",
//   appId: "1:60602324384:web:0e335effff3f936d1b00c5"
// };

// const firebaseConfig = {
//     apiKey: "AIzaSyC7HUfblTTJKvBWINyDxwmZbUfZPhcX0vM",
//     authDomain: "test-rebla.firebaseapp.com",
//     projectId: "test-rebla",
//     storageBucket: "test-rebla.appspot.com",
//     messagingSenderId: "674551819684",
//     appId: "1:674551819684:web:24cfd50b46bf97ebfb6531"
// };

exports.config = firebaseConfig;